import { EmployeeColumnFilterField } from "@/pages/employees/index/EmployeeColumnFilterField.tsx";
import { ColumnFilterValue } from "@/pages/employees/index/employee-column-filter-conditions.ts";
import { EMPLOYEE_FILTER_RENDERERS } from "@/pages/employees/index/employee-filter-value-renderers.tsx";
import {
  ApiEmployeeColumn,
  ApiEmployeeColumnFilter,
} from "@/types/employees/employee-column.types.ts";
import { Button, Modal, ModalProps, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface ColumnFilterValueModalProps extends ModalProps {
  column: ApiEmployeeColumn;
  label: string;
  filter: ApiEmployeeColumnFilter;
  onApply: (filter: ApiEmployeeColumnFilter) => void;
}

export function ColumnFilterValueModal({
  column,
  label,
  filter,
  onApply,
  ...props
}: ColumnFilterValueModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const [draft, setDraft] = useState<ApiEmployeeColumnFilter>(filter);

  const handleApply = () => {
    onApply(draft);
    close(props.id);
  };

  return (
    <Modal
      {...props}
      variant="middle"
      size="md"
      title={t("reporting:people_analytics_filter_by", { name: label })}
      withCloser
      closeByEscEnabled
      actions={
        <Button size="lg" className="w-full" onClick={handleApply}>
          {t("common:filter_apply")}
        </Button>
      }
    >
      <EmployeeColumnFilterField
        column={{ ...column, title: label }}
        filter={draft}
        onChange={(value: ColumnFilterValue) => setDraft({ field: column.id, ...value })}
        renderers={EMPLOYEE_FILTER_RENDERERS}
      />
    </Modal>
  );
}
